import * as FileSaver from 'file-saver';

function saveFile(url,name){
    FileSaver.saveAs(url, name);
}

export default saveFile


// WEBPACK FOOTER //
// ./src/api/utils.ts